module.exports = __webpack_public_path__ + "img/popover-coupon-icon.5126379.png";